import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsxs("g", {
    children: [/*#__PURE__*/_jsx("path", {
      className: "line",
      d: "M5 27 l22 0",
      strokeWidth: "2",
      stroke: "black"
    }), /*#__PURE__*/_jsx("path", {
      className: "line",
      d: "M16 5 l0 18",
      strokeWidth: "2",
      stroke: "black"
    }), /*#__PURE__*/_jsx("path", {
      className: "line",
      d: "M9 16 l8 8",
      strokeWidth: "2",
      stroke: "black"
    }), /*#__PURE__*/_jsx("path", {
      className: "line",
      d: "M23 16 l-8 8",
      strokeWidth: "2",
      stroke: "black"
    })]
  });
});